import * as React from "react";

import { style, MyIconProps } from "./MyIcons";

export const PowerTurnOn = (props: MyIconProps): React.ReactElement => {
  return (
    <svg
      ref={props.elementRef}
      className={props.className}
      style={{ ...style(props), ...props.style }}
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    >
      <path d="M18.364 5.63604C21.8787 9.15076 21.8787 14.8492 18.364 18.3639C14.8493 21.8787 9.1508 21.8787 5.6361 18.3639C2.12138 14.8492 2.12138 9.15074 5.6361 5.63604C9.15082 2.12132 14.8493 2.12132 18.364 5.63604" />
      <path d="M12 7V12" />
      <path d="M15.534 8.46606C17.486 10.4181 17.486 13.5831 15.534 15.5351C13.582 17.4871 10.417 17.4871 8.465 15.5351C6.513 13.5831 6.513 10.4181 8.465 8.46606" />
    </svg>
  );
};
